import axiosInstance from './axiosConfig';
import {
  AIExplanationRequest,
  AIExplanationResponse,
  ClinicalNotesRequest,
  ClinicalNotesResponse
} from '../types/code.types';

export const aiApi = {
  explainCode: async (request: AIExplanationRequest, signal?: AbortSignal): Promise<AIExplanationResponse> => {
    const response = await axiosInstance.post('/ai/explain', request, { signal });
    return response.data;
  },

  extractCodes: async (request: ClinicalNotesRequest): Promise<ClinicalNotesResponse> => {
    const response = await axiosInstance.post('/ai/extract-codes', request);
    return response.data;
  },

  translate: async (text: string, targetLanguage: string): Promise<{ translation: string }> => {
    const response = await axiosInstance.post('/ai/translate', {
      text,
      targetLanguage
    });
    return response.data;
  }
};